<template>
  <div>
    <knowledge-categories
      v-if="currentServiceArea && currentServiceArea.articles && currentServiceArea.articles.length"
      :current-service-area="currentServiceArea"
      :service-areas="categoriesList"
      @clickBKRoute="clickBKRoute"
      :showDropdownForKnowledgeBrowse="showDropdownForKnowledgeBrowse"
    ></knowledge-categories>
    <knowledge-services v-if="!isLoading" :articles="standardArticles"></knowledge-services>
  </div>
</template>

<script>
import KnowledgeCategories from "@/components/knowledge-article/KnowledgeCategories.vue";
import KnowledgeServices from "@/components/knowledge-article/KnowledgeServices.vue";
import * as CONSTANTS from "@/store/constants";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "BrowseKnowledge",
  components: {
    KnowledgeCategories,
    KnowledgeServices
  },
  watch: {
    errorMessage: function() {
      if (this.errorMessage && this.errorMessage.length) {
        this.$router.push({ name: "page-not-found" });
      }
    },
    "$route.params": {
      handler(oldValue, newValue) {
        if (newValue && newValue.id) {
          let categoryFromList = this.getCurrentCategoryFromList();
          this.setCurrentCategory(categoryFromList);
          this.getArticlesCategories();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      "standardCategories",
      "standardArticles",
      "platformCategory",
      "platformCategories",
      "currentCategory",
      "isLoading",
      "articlesLoading",
      "errorMessage"
    ]),
    categoriesList() {
      //Adding "All" category object to categories array
      let currentAllObject = this.allObject;
      let categories = [currentAllObject, ...this.standardCategories];
      return categories;
    },
    currentServiceArea() {
      const serviceAreaId = this.$route.params.id;
      if (serviceAreaId) {
        return this.currentCategory
          ? this.currentCategory
          : this.getCurrentCategoryFromList();
      }
      return this.allObject;
    },
    checkAllCategoryUrl() {
      return !this.$route.params.id;
    },
    allObject() {
      //Creating All category object
      return {
        name: CONSTANTS.CAPITALIZE_ALL_TEXT,
        id: null,
        articles: this.spreadArticleCategories
      };
    },
    spreadArticleCategories() {
      let singleArticleCategories = [];
      for (var i = 0; i < this.standardCategories.length; i++) {
        singleArticleCategories = singleArticleCategories.concat(
          this.standardCategories[i].articles
        );
      }

      return singleArticleCategories;
    }
  },
  created() {
    this.getArticlesCategories();
  },
  data() {
    return {
      showDropdownForKnowledgeBrowse: true
    }
  },
  methods: {
    ...mapActions(["fetchArticlesCategories", "fetchPlatformArticles"]),
    ...mapMutations([
      "setArticlesLoading",
      "setCurrentCategory",
      "setStandardArticles"
    ]),

    clickBKRoute(bk) {
      if (!this.$route.params.id) {
        this.$hhMixpanel.trackEvent(
          `${this.platformCategory} Knowledge Browse - All`
        );
        //Spread categories array to get articles list
        let articleCategoriesObj = {
          name: CONSTANTS.CAPITALIZE_ALL_TEXT,
          articles: this.spreadArticleCategories
        };
        //Storing "All" category object for the dropdown
        this.setCurrentCategory(articleCategoriesObj);
        //Storing articles list to display it.
        this.setStandardArticles(this.spreadArticleCategories);
        this.setArticlesLoading(false);
      } else {
        let requestObject = {
          platformCategory: this.platformCategory,
          serviceId: bk.id
        };
        if (bk.articles) {
          this.setStandardArticles(bk.articles);
          this.setArticlesLoading(false);
        } else {
          this.fetchPlatformArticles(requestObject).finally(() => {
            this.setArticlesLoading(false);
          });
          this.$hhMixpanel.trackEvent(
            `${this.platformCategory} Knowledge Browse - ${bk.name}`
          );
        }
      }
    },
    getArticlesCategories() {
      let fetchArticlesObject = {
        platformCategory: this.platformCategory
      };
      this.setArticlesLoading(true);
      this.fetchArticlesCategories(fetchArticlesObject).then(() => {
        if(this.standardCategories && this.standardCategories.length === 1) {
          this.showDropdownForKnowledgeBrowse = false
        }
        this.clickBKRoute(this.currentServiceArea);
      });
    },
    getCurrentCategoryFromList() {
      let sa = this.standardCategories.find(
        item => ( item.id === this.$route.params.id || ( item.serviceNowSysId && item.serviceNowSysId === this.$route.params.id ) )
      );

      return sa ? sa : {};
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/knowledge-article/BrowseKnowledge.vue